import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-search-blue",
  "use": "icon-search-blue-usage",
  "viewBox": "0 0 24 23.83",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 23.83\" id=\"icon-search-blue\"><title>ikon_sok</title><path d=\"M18.43,16.86A10.33,10.33,0,0,0,17.66,3,10.45,10.45,0,0,0,3,3L2.94,3a10.29,10.29,0,0,0,.13,14.53A10.4,10.4,0,0,0,17,18.3l5.57,5.53L24,22.39Zm.24-6.52a8.16,8.16,0,0,1-2.39,5.82,8.38,8.38,0,0,1-11.76-.07l0,0a8.24,8.24,0,0,1,0-11.64,8.39,8.39,0,0,1,11.76.07l0,0A8.15,8.15,0,0,1,18.67,10.34Z\" style=\"fill:#19384e\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol